var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnterOtpPana(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-105"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.63,
    y: 50.06,
    width: 68.8,
    height: 71.72,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.97,
    y: 50.06,
    width: 68.8,
    height: 71.72,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.79,121.8H56V50h68.84Zm-68.8,0h68.75V50.08H56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.22,
    y: 59.7,
    width: 50.3,
    height: 52.43,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.22,112.49A8.65,8.65,0,0,1,64,113.93c-.8.85-1.93,2-3.19,3.24s-2.43,2.36-3.29,3.15A9,9,0,0,1,56,121.53a7.48,7.48,0,0,1,1.23-1.44c.81-.85,1.94-2,3.21-3.25s2.43-2.36,3.29-3.15A7.48,7.48,0,0,1,65.22,112.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.52,112.36A8.23,8.23,0,0,1,117,113.6c.85.8,2,1.93,3.24,3.19s2.36,2.43,3.15,3.29a8.4,8.4,0,0,1,1.21,1.45,7.48,7.48,0,0,1-1.44-1.23c-.85-.8-2-1.93-3.25-3.2s-2.36-2.44-3.15-3.3A7.29,7.29,0,0,1,115.52,112.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.38,59.84a8.36,8.36,0,0,1,1.24-1.44c.8-.85,1.93-2,3.2-3.24s2.43-2.36,3.28-3.15a7.8,7.8,0,0,1,1.46-1.21,8.23,8.23,0,0,1-1.24,1.44c-.8.85-1.93,2-3.2,3.25s-2.44,2.36-3.29,3.15A7.48,7.48,0,0,1,115.38,59.84Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.08,60a7.94,7.94,0,0,1-1.44-1.24c-.85-.8-2-1.93-3.25-3.2S58,53.1,57.25,52.25A7.32,7.32,0,0,1,56,50.79,8,8,0,0,1,57.47,52c.85.8,2,1.93,3.25,3.2s2.37,2.44,3.15,3.29A7.84,7.84,0,0,1,65.08,60Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.38,112.14s0-.09,0-.26,0-.42,0-.73c0-.66,0-1.6,0-2.83,0-2.48,0-6.1-.06-10.69,0-9.18,0-22.26-.09-37.93l.19.2-50.16,0h0l.22-.22c0,19.25,0,37.25,0,52.44l-.19-.19,36.32.09,10.2,0,2.7,0,.7,0a.93.93,0,0,1,.24,0h-.9l-2.66,0-10.16,0-36.44.1H65v-.19C65,97,65,79,65,59.7v-.22h.23l50.16,0h.19v.19c0,15.72-.07,28.84-.09,38.06,0,4.57,0,8.17-.06,10.64,0,1.21,0,2.14,0,2.79,0,.31,0,.54,0,.71A2.17,2.17,0,0,1,115.38,112.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.97,
    y: 77.53,
    width: 16.78,
    height: 16.78,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 630.63,
    y: 47.9,
    width: 77.46,
    height: 112.28,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 626.75,
    y: 47.9,
    width: 77.46,
    height: 112.28,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 636.38,
    y: 60.06,
    width: 58.22,
    height: 87.96,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.59,148s0-.15,0-.43,0-.71,0-1.25c0-1.1,0-2.72,0-4.82,0-4.22,0-10.36-.06-18.12,0-15.51,0-37.48-.09-63.34l.19.19-58.21,0h0l.21-.21c0,33.18,0,63.78-.05,88l-.16-.17,42.37.09,11.71,0,3.07,0,1.06,0-1,0-3,0-11.67,0-42.47.09h-.17V148c0-24.18,0-54.78-.05-88v-.21h.22l58.21,0h.19v.19c0,25.92-.07,47.92-.09,63.47,0,7.74,0,13.87-.05,18.07,0,2.08,0,3.69,0,4.79,0,.53,0,.94,0,1.22S694.59,148,694.59,148Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.43,47.9a13.19,13.19,0,0,1-1.38,2c-.9,1.21-2.17,2.84-3.63,4.61s-2.82,3.34-3.83,4.46a13.76,13.76,0,0,1-1.71,1.74,14.58,14.58,0,0,1,1.48-1.94l3.73-4.52,3.73-4.53A15.58,15.58,0,0,1,704.43,47.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.89,147.74A72.55,72.55,0,0,0,705,160.44",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705,160.44a12.51,12.51,0,0,1-1.77-1.62,53,53,0,0,1-3.83-4.32,55.09,55.09,0,0,1-3.37-4.68,10.93,10.93,0,0,1-1.18-2.08,15.73,15.73,0,0,1,1.43,1.91c.85,1.2,2,2.84,3.45,4.59s2.74,3.28,3.72,4.38A14.55,14.55,0,0,1,705,160.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.74,160.09l10.15-12.52",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.89,147.57A75.44,75.44,0,0,1,632,154a77.23,77.23,0,0,1-5.24,6.13,79.38,79.38,0,0,1,4.91-6.39A77,77,0,0,1,636.89,147.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.75,47.9a69.56,69.56,0,0,1,4.93,5.89,67.39,67.39,0,0,1,4.59,6.15,70.4,70.4,0,0,1-4.92-5.89A72.29,72.29,0,0,1,626.75,47.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 656.96,
    y: 77.92,
    width: 19.49,
    height: 55.35,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.57,252.1a33.45,33.45,0,0,0-14.3-4.92c-2.34-.24-4.89-.17-6.76,1.25a1.38,1.38,0,0,0-.7,1.23,1.52,1.52,0,0,0,.66.85,20.45,20.45,0,0,0,21.1,1.59",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.21,251.7A69.47,69.47,0,0,1,50,243.57a23.33,23.33,0,0,1-5.79-10.71,4.32,4.32,0,0,1,.45-3.58C52,235,57.78,242.47,59.21,251.7",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5,252.05a33.18,33.18,0,0,1,.17-12.13,16.39,16.39,0,0,1,6.46-10c1.27,3,.72,6.4-.17,9.51a46.35,46.35,0,0,1-6.41,13.49",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.71,265c-4.38.53-8.19,2.84-11.46,5.81a21.68,21.68,0,0,0-6.57,11.26c4.3-.27,8-3.3,10.59-6.7s4.48-7.12,7.38-10.3",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.28,267.05a28.28,28.28,0,0,1,3.27-26.76c2.49,8.88,1.58,18.91-3.27,26.76",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.82,278.41a20.43,20.43,0,0,0-19.56,11.26c-.24.48-.46,1.1-.13,1.53a1.45,1.45,0,0,0,1.3.38c3.85-.25,7.27-2.57,10.09-5.21s5.27-5.69,8.39-8",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.52,277.79a36.4,36.4,0,0,1-.37-20.35c.72-2.62,1.92-5.38,4.34-6.6a.85.85,0,0,1,.67-.12.93.93,0,0,1,.42.49,12.24,12.24,0,0,1,1,5.83,36.86,36.86,0,0,1-.91,5.91c-.77,3.61-1.17,7.5-3.15,10.61a21,21,0,0,0-1.26,2.33c-.38.79-.38,1.07-.72,1.7",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.76,281.55c-1.87-7.11.12-15.74,4.6-21.57.33-.43.77-.89,1.31-.84.82.07,1,1.17,1,2a39,39,0,0,1-6.91,20.41",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105,283.11a31.39,31.39,0,0,0,25.74-5.24,20.79,20.79,0,0,0-13.93-1.71c-4.66,1.06-8.92,3.15-11.81,6.95",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107,278.37c4.84-7.89,14.12-13.05,23.36-13.51-1.06,3.76-4.15,6.68-7.64,8.45s-7.38,2.53-11.22,3.28c-1.49.29-3.54.61-4.5,1.78",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.24,255.38a68,68,0,0,0,3-13.68c.36-4.67-.31-9.54-2.73-13.54-4.52,8.75-5,19-.39,27.69",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.47,247.69c5.28-9.61,16.07-17.29,27-18.37-4.21,10.49-15.7,18.59-27,18.37",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.14,249.57c7.88,1.2,14.6,6.24,22,9.29a9.7,9.7,0,0,0,5,.95,3.89,3.89,0,0,0,2.44-6.88,10.55,10.55,0,0,0-3.61-2.18c-8-3.35-16.64-3.43-25.09-1.4",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.57,255.1c1.79.51,2.4,1.44,3.81,2.64a41.06,41.06,0,0,0,16.67,8.56c.63.16,1.47.22,1.79-.35s-.08-1.11-.44-1.56a22.84,22.84,0,0,0-10.06-6.83c-3.84-1.43-7.18-3.16-11.77-2.79",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.42,221.69a31.55,31.55,0,0,0,24.18,8.23,1.68,1.68,0,0,0,1.1-.39c.61-.67-.12-1.69-.83-2.24-7.11-5.54-15.72-7.84-24.45-5.6",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.53,219.46a33.7,33.7,0,0,1,30.17-5,23.9,23.9,0,0,1-14.38,6.31,45.26,45.26,0,0,1-15.79-1.33",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.1,204.11c-.69-7.1-.24-12.7-.73-19.83,0-.57-.17-1.25-.7-1.46-.74-.28-1.36.63-1.6,1.39a22.73,22.73,0,0,0,3,19.74",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.59,204.89a41.78,41.78,0,0,0,11.76-11.42c2.32-3.18,4.28-7,3.75-10.88a11.23,11.23,0,0,0-8.48,4.21,23.65,23.65,0,0,0-4.32,8.69c-.94,3.13-1.6,6.33-2.71,9.4",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.14,201.68a94.65,94.65,0,0,0,28.93-17.05c-3.46-1.39-7.42-.56-10.87.83A34.3,34.3,0,0,0,120,201.61",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.84,208.77c5.34.59,10.76,1,16.06.08s10.13-2.93,15-5a1.73,1.73,0,0,0,1-.77,1.17,1.17,0,0,0-.36-1.29,3.22,3.22,0,0,0-1.28-.6c-5.29-1.47-11-.78-16.2,1a75.3,75.3,0,0,0-14.23,6.59",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.35,221.94c-3.64-7.36-3.41-15.94-.26-23.52,2.22,3.38,2.49,7.68,2.08,11.69s-1.63,8.16-1.7,12.19",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8,214.6A32.75,32.75,0,0,0,42.43,225a22.76,22.76,0,0,0,13.34-2.48,67.52,67.52,0,0,0,11.44-7.65",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57,211.32c-4.45-.36-8.73-.91-13,.4a15.64,15.64,0,0,0-9.91,8.41,23.51,23.51,0,0,0,12.2-2.3A69.48,69.48,0,0,0,57,211.32",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5,211.47c-4-2.62-8.11-5.29-12.77-6.38s-10.07-.28-13.32,3.23c3.78,2.22,8.35,2.48,12.73,2.48s9.74-.06,13.86,1.4",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.52,211.69c-6.84-6.72-9.43-18.8-6.68-28a42.58,42.58,0,0,1,6.68,28",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.34,192.65c1.29-3,2.2-6.15,3.36-9.21A26.4,26.4,0,0,1,98.48,175a12.59,12.59,0,0,1,8.48-4.39,34.14,34.14,0,0,1-16.45,22.12",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.94,196.61c-2.14-2.94-4.61-6.93-7.5-9.12s-6.67-3.52-10.21-2.68a23.74,23.74,0,0,0,17.71,11.8",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.62,192.89A51,51,0,0,1,84.24,182,17.12,17.12,0,0,1,86,170.84c3.76,7.1,5,14.72,1.86,22.13",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.38,170.84c2.12-7,8.57-12.22,15.53-14.6a5.8,5.8,0,0,1,2.72-.41,2.36,2.36,0,0,1,2,1.68c.25,1.2-.74,2.27-1.67,3.06a52.87,52.87,0,0,1-18.59,10.27",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.45,165.09c.27-4.54.56-9.15,2-13.45s4.32-8.33,8.46-10.21c.71,4.58-1.32,9.14-3.75,13.08s-5.38,7.67-6.85,12.07",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.34,168.21c-1.76-5.13-1.94-11.65-5-16.12-2.15-3.12-5.59-5.25-7.44-8.56a13,13,0,0,0,.44,9.72A28.1,28.1,0,0,0,84,161.39c2.27,2.42,4.22,4.25,6.33,6.82",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.38,319.29c-.14,0-.26-34.23-.27-76.43s.09-76.44.23-76.44.26,34.22.27,76.44S90.51,319.29,90.38,319.29Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.28,216.77a6.38,6.38,0,0,1-1.28.49l-3.55,1.19c-3,1-7.08,2.49-11.53,4.32s-8.57,3.42-10.94,5.47a8,8,0,0,0-2.19,2.91c-.34.8-.4,1.29-.45,1.28s0-.12,0-.35a4.93,4.93,0,0,1,.25-1,7.72,7.72,0,0,1,2.14-3.1A19.57,19.57,0,0,1,97.49,225c1.9-.88,4-1.81,6.24-2.72,4.46-1.83,8.6-3.26,11.62-4.19,1.5-.47,2.74-.82,3.59-1.05A8.29,8.29,0,0,1,120.28,216.77Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.09,192.69s-.12.15-.37.39l-1.09,1-4.1,3.73L110.88,210c-5.32,4.75-9.93,9.28-13.12,12.69-1.6,1.7-2.85,3.11-3.71,4.1l-1,1.13c-.23.26-.36.39-.37.37s.08-.16.29-.43.51-.69.92-1.2c.82-1,2-2.47,3.6-4.21a175.87,175.87,0,0,1,13-12.81c5.35-4.73,10.21-9,13.75-12.05l4.2-3.6,1.16-1A2.27,2.27,0,0,1,130.09,192.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.13,214.81c-.14-.07,1-2.64,2.08-5.88s1.65-6,1.79-6a20.15,20.15,0,0,1-1.32,6.12A41.61,41.61,0,0,1,106,213.2,6.85,6.85,0,0,1,105.13,214.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.41,235.52a5.9,5.9,0,0,1-.82-1l-2.11-2.7c-1.76-2.28-4.2-5.43-6.94-8.88s-5.25-6.55-7.08-8.78l-2.15-2.66a7.18,7.18,0,0,1-.74-1,6.44,6.44,0,0,1,.89.89c.55.6,1.32,1.47,2.27,2.56,1.89,2.18,4.45,5.25,7.2,8.7s5.14,6.64,6.83,9c.85,1.17,1.53,2.12,2,2.79A6.64,6.64,0,0,1,90.41,235.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.85,227.1A12.07,12.07,0,0,1,81.1,222a14.92,14.92,0,0,1-.62-5.19l.22,0c-.1.4-.17.61-.21.6s0-.23,0-.63h.22a23.49,23.49,0,0,0,.88,5A37.49,37.49,0,0,0,83.85,227.1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.38,216.45a8.6,8.6,0,0,0-1.91-1.11,12.79,12.79,0,0,0-5.33-.43,33.47,33.47,0,0,0-5.36.87,15.39,15.39,0,0,1-2.21.53,7.82,7.82,0,0,1,2.11-.87,25,25,0,0,1,5.42-1,11.75,11.75,0,0,1,5.5.59A3.38,3.38,0,0,1,75.38,216.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.38,213.87c0,.08-1.12-.45-2.94-1.07a30.72,30.72,0,0,0-7.33-1.51,30.35,30.35,0,0,0-7.48.38c-1.89.34-3,.7-3.07.61a3.35,3.35,0,0,1,.78-.33,17.54,17.54,0,0,1,2.22-.62,26.18,26.18,0,0,1,15,1.14,20.17,20.17,0,0,1,2.1.95A2.9,2.9,0,0,1,73.38,213.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.34,203a61.62,61.62,0,0,1-2.14-7.45A62.42,62.42,0,0,1,86.53,188a58,58,0,0,1,2.15,7.44A61.06,61.06,0,0,1,90.34,203Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.48,203a37.24,37.24,0,0,0-2.38-4.46,20.53,20.53,0,0,0-3.49-3.61,3.28,3.28,0,0,1,1.35.7,11.08,11.08,0,0,1,2.55,2.63A9.89,9.89,0,0,1,90.48,203Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.38,301c-.06,0-.16-.82-.54-2.27a32.77,32.77,0,0,0-2.29-5.93c-2.37-4.83-6.67-11-12.13-17.09-2.71-3.1-5.34-6-7.57-8.81a61.29,61.29,0,0,1-5.41-7.81,38.12,38.12,0,0,1-2.74-5.79c-.25-.71-.43-1.27-.53-1.66a2.3,2.3,0,0,1-.14-.59s.29.79.85,2.18A43.35,43.35,0,0,0,62.74,259a65.82,65.82,0,0,0,5.46,7.69c2.24,2.77,4.87,5.67,7.59,8.77,5.48,6.15,9.77,12.36,12.07,17.27a29,29,0,0,1,2.16,6,17.22,17.22,0,0,1,.31,1.72A3.36,3.36,0,0,1,90.38,301Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.4,270.52a12.29,12.29,0,0,1-1.42.79,32.21,32.21,0,0,0-3.67,2.43,41.81,41.81,0,0,0-4.82,4.4c-1.7,1.79-3.44,3.87-5.22,6.09-3.56,4.47-6.89,8.42-8.88,11.58a43.14,43.14,0,0,0-2.23,3.81,13.58,13.58,0,0,1-.78,1.42s0-.14.13-.4.25-.64.47-1.11a36.82,36.82,0,0,1,2.11-3.91c1.94-3.23,5.24-7.24,8.79-11.7,1.79-2.23,3.55-4.31,5.28-6.09a39.05,39.05,0,0,1,4.94-4.37,25.7,25.7,0,0,1,3.79-2.32c.47-.23.86-.38,1.11-.49S117.39,270.5,117.4,270.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.93,280.42a21.31,21.31,0,0,1-3,.44,38.58,38.58,0,0,0-7.1,1.39,21.61,21.61,0,0,0-6.36,3.34c-1.47,1.13-2.16,2.07-2.23,2a2.41,2.41,0,0,1,.45-.68,11.14,11.14,0,0,1,1.56-1.6,19.32,19.32,0,0,1,6.42-3.54,32.14,32.14,0,0,1,7.22-1.27A16.7,16.7,0,0,1,117.93,280.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.13,286.52c-.16-.09,1.19-2.15,2.24-4.92s1.21-5.25,1.39-5.23a5,5,0,0,1-.05,1.61,17.33,17.33,0,0,1-.88,3.78,18.26,18.26,0,0,1-1.73,3.47A5.25,5.25,0,0,1,100.13,286.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.15,243.93a1.79,1.79,0,0,1-.48.26l-1.4.64c-.62.26-1.37.6-2.21,1s-1.83.89-2.86,1.5l-1.63.93c-.57.33-1.13.72-1.73,1.09-1.2.73-2.41,1.63-3.69,2.55a63,63,0,0,0-14.24,14.73c-.88,1.32-1.74,2.56-2.42,3.78-.36.61-.72,1.19-1,1.76l-.87,1.67c-.58,1-1,2.05-1.41,2.91s-.72,1.61-1,2.24-.44,1.05-.59,1.43a3.23,3.23,0,0,1-.24.48,2,2,0,0,1,.14-.52c.13-.38.3-.87.51-1.46a23.6,23.6,0,0,1,.89-2.28c.38-.88.78-1.9,1.35-3l.84-1.69c.3-.58.66-1.17,1-1.78.68-1.25,1.53-2.5,2.4-3.84a61.14,61.14,0,0,1,14.34-14.84c1.31-.91,2.53-1.81,3.75-2.53.61-.37,1.18-.75,1.75-1.07l1.66-.9c1-.6,2-1,2.91-1.45s1.62-.73,2.25-1l1.45-.55A2.55,2.55,0,0,1,126.15,243.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.76,258.26a3.57,3.57,0,0,1,1.18-1.75,7.48,7.48,0,0,1,4.74-1.82,13.08,13.08,0,0,1,5,1,7.51,7.51,0,0,1,1.88.91,11.38,11.38,0,0,1-2-.58,15.2,15.2,0,0,0-4.86-.81,7.67,7.67,0,0,0-4.52,1.59A15.39,15.39,0,0,0,104.76,258.26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.57,261.56a12.71,12.71,0,0,0,1-8.95,3,3,0,0,1,.56,1.28,9.12,9.12,0,0,1-.77,6.56C102,261.21,101.62,261.6,101.57,261.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.74,306c.74,13.07,4.68,26.38,10.74,39.82h26.36c5.78-13.31,9.45-26.59,10.1-39.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.67,327.11c0,.14-8.68.25-19.38.25s-19.39-.11-19.39-.25,8.68-.25,19.39-.25S109.67,327,109.67,327.11Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.08,331.85c0,.13-8.13.24-18.17.24s-18.17-.11-18.17-.24,8.13-.25,18.17-.25S109.08,331.71,109.08,331.85Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.91,314.53a77,77,0,0,1,0,12.15,73.94,73.94,0,0,1,0-12.15Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92,314.53a79.25,79.25,0,0,1,0,12.58,79.25,79.25,0,0,1,0-12.58Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.29,314.43a41,41,0,0,1,.25,6.41,41,41,0,0,1-.25,6.41,41,41,0,0,1-.25-6.41A41,41,0,0,1,105.29,314.43Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.11,314.53c0,.14-10.18.25-22.74.25s-22.73-.11-22.73-.25,10.17-.24,22.73-.24S113.11,314.4,113.11,314.53Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 638.58,
    y: 185.99,
    width: 66.89,
    height: 69.72,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 634.05,
    y: 185.99,
    width: 66.89,
    height: 69.72,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701,255.74H634V186H701Zm-66.88,0h66.84V186H634.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 643.05,
    y: 195.37,
    width: 48.9,
    height: 50.98,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.05,246.68a8.61,8.61,0,0,1-1.21,1.41c-.78.82-1.88,1.94-3.11,3.15s-2.36,2.29-3.19,3.06a8.22,8.22,0,0,1-1.42,1.17,8,8,0,0,1,1.2-1.39c.78-.83,1.88-2,3.12-3.16s2.36-2.3,3.2-3.07A8,8,0,0,1,643.05,246.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692,246.56a7.82,7.82,0,0,1,1.4,1.2c.83.79,1.94,1.88,3.15,3.11s2.3,2.36,3.06,3.2a7.82,7.82,0,0,1,1.18,1.41,8.26,8.26,0,0,1-1.4-1.2c-.82-.78-1.94-1.88-3.16-3.11s-2.29-2.37-3.06-3.21A7.13,7.13,0,0,1,692,246.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.82,195.5a7.82,7.82,0,0,1,1.2-1.4c.78-.82,1.88-1.94,3.11-3.15s2.36-2.29,3.2-3.06a7.82,7.82,0,0,1,1.41-1.18,7.43,7.43,0,0,1-1.2,1.4c-.78.82-1.88,1.94-3.12,3.16s-2.36,2.29-3.2,3.06A7.49,7.49,0,0,1,691.82,195.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.91,195.63a8.22,8.22,0,0,1-1.4-1.21c-.83-.78-1.94-1.88-3.15-3.11s-2.29-2.36-3.06-3.19a7.65,7.65,0,0,1-1.18-1.42,7.82,7.82,0,0,1,1.4,1.2c.82.79,1.94,1.89,3.16,3.12s2.29,2.37,3.06,3.2A7,7,0,0,1,642.91,195.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.82,246.34a1.1,1.1,0,0,1,0-.24c0-.18,0-.41,0-.72,0-.63,0-1.55,0-2.75,0-2.41,0-5.93,0-10.39,0-8.93-.05-21.64-.09-36.87l.19.19-48.77,0h0l.21-.21c0,18.71,0,36.21,0,51l-.18-.18,35.31.09,9.92.05,2.62,0h0l-2.59,0-9.87,0-35.43.1h-.19v-.19c0-14.76,0-32.26,0-51v-.22h.22l48.77,0H692v.19c0,15.28-.07,28-.09,37,0,4.45,0,7.95,0,10.35,0,1.18,0,2.09,0,2.72,0,.29,0,.52,0,.69S691.82,246.35,691.82,246.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 659.34,
    y: 212.7,
    width: 16.32,
    height: 16.32,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "467.52 429.13 467.52 460.76 513.77 460.76 564.79 460.76 564.79 429.13 467.52 429.13",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "463.44 420.29 463.44 429.13 568.2 429.13 568.2 420.29 513.77 420.29 463.44 420.29",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "515.82 460.76 564.79 460.76 564.79 429.13 568.2 429.13 568.2 420.29 513.77 420.29 513.77 428.31 515.82 460.76",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 481.12,
    y: 434.23,
    width: 19.73,
    height: 4.76,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 478.58,
    y: 444.95,
    width: 25.33,
    height: 10.05,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "482.48 388.7 482.48 420.33 528.74 420.33 579.76 420.33 579.76 388.7 482.48 388.7",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "478.4 379.85 478.4 388.7 583.16 388.7 583.16 379.85 528.74 379.85 478.4 379.85",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "530.78 420.33 579.76 420.33 579.76 388.7 583.16 388.7 583.16 379.85 528.74 379.85 528.74 387.88 530.78 420.33",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 496.09,
    y: 393.8,
    width: 19.73,
    height: 4.76,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 493.55,
    y: 404.51,
    width: 25.33,
    height: 10.05,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-105"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M703.33,347c0,.14-148.4.26-331.41.26S40.48,347.13,40.48,347s148.36-.26,331.44-.26S703.33,346.85,703.33,347Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.1,461.1c0,.14-142,.26-317.18.26s-317.21-.12-317.21-.26,142-.26,317.21-.26S689.1,461,689.1,461.1Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-105"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 163.9,
    y: 46.99,
    width: 443.49,
    height: 293.28,
    rx: 14.57,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.82,340.27l.95-.06a7,7,0,0,0,1.15-.13,9.42,9.42,0,0,0,1.59-.33,13.52,13.52,0,0,0,4.19-1.85,14.33,14.33,0,0,0,4.41-4.49A15.07,15.07,0,0,0,606.7,330a15.91,15.91,0,0,0,.62-4.18c0-3,0-6.23,0-9.76,0-7.05,0-15.19,0-24.35,0-36.65,0-89.69-.08-155.22q0-24.57,0-51.43V64.59a24.75,24.75,0,0,0-.53-6.83,14.36,14.36,0,0,0-9.1-9.74,14,14,0,0,0-1.68-.48c-.57-.12-1.15-.2-1.73-.27-1.17-.08-2.36-.07-3.56-.06H583.4l-123,0-281.88,0a14.37,14.37,0,0,0-13.74,10.23,15.6,15.6,0,0,0-.6,4.52v50.71q0,36.53,0,71.92c0,47.16,0,92.64,0,136v4a19.5,19.5,0,0,0,.3,4,14.49,14.49,0,0,0,3.63,6.92,14,14,0,0,0,3.07,2.45,15.9,15.9,0,0,0,1.74.9,15,15,0,0,0,1.86.62c2.52.74,5.19.46,7.83.51h90.95l107.19,0,155.2.09,42.2.05,11,0,3.73,0-3.73,0-11,0-42.2.05-155.2.08-107.19,0-59.72,0H178.61a15,15,0,0,1-4-.52,16.62,16.62,0,0,1-1.92-.64,18.12,18.12,0,0,1-1.8-.94,14.23,14.23,0,0,1-3.16-2.53,14.55,14.55,0,0,1-2.37-3.3,15.9,15.9,0,0,1-1.39-3.84,20,20,0,0,1-.31-4.08v-4c0-43.33,0-88.81,0-136V62a15.75,15.75,0,0,1,.62-4.67,14.89,14.89,0,0,1,14.24-10.6l281.88,0,123,0h7.19c1.2,0,2.38,0,3.59.07a18,18,0,0,1,1.79.27,14.91,14.91,0,0,1,11.09,10.53l.22.85c.06.29.09.58.14.87a12.94,12.94,0,0,1,.16,1.75c0,1.17,0,2.32,0,3.47v6.87q0,6.84,0,13.55,0,26.83,0,51.43c0,65.53-.07,118.57-.09,155.22,0,9.16,0,17.3,0,24.35,0,3.53,0,6.79,0,9.76a15.8,15.8,0,0,1-.64,4.22,14.77,14.77,0,0,1-1.61,3.47,14.31,14.31,0,0,1-4.46,4.51,13.59,13.59,0,0,1-4.21,1.83,9.8,9.8,0,0,1-1.6.32,6.85,6.85,0,0,1-1.16.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.26,347H164.36a17.8,17.8,0,0,1-17.79-17.8v-7.86H627.06v7.86A17.8,17.8,0,0,1,609.26,347Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.26,347l.58,0a16.68,16.68,0,0,0,1.71-.15l1.27-.2,1.51-.39c.55-.16,1.11-.4,1.73-.62s1.25-.57,1.9-.94a18.62,18.62,0,0,0,4-3.07,17.78,17.78,0,0,0,5-12c0-2.57,0-5.33,0-8.26l.1.09-462.67.17H146.57l.26-.26v6.25a20.85,20.85,0,0,0,.6,6.12,17.48,17.48,0,0,0,6.85,9.82,18.24,18.24,0,0,0,11.49,3.21H316.44l152.72.06,102.58.08,27.83.05,7.23,0,2.46,0-2.46,0-7.23,0-27.83,0-102.58.08-152.72.06H165.77A18.76,18.76,0,0,1,154,344a18,18,0,0,1-7-10.12,21.6,21.6,0,0,1-.62-6.25v-6.51h18.08l462.67.16h.09v.1c0,2.93,0,5.68,0,8.27A17.81,17.81,0,0,1,622,341.66a18.85,18.85,0,0,1-4,3.08c-.66.37-1.31.65-1.91.93s-1.2.46-1.75.61l-1.52.38-1.27.19a13.15,13.15,0,0,1-1.72.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "341.93 321.33 347.89 330.81 431.79 330.81 437.32 321.33 341.93 321.33",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.42,
    y: 67.03,
    width: 402.07,
    height: 238.49,
    rx: 8.48,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.83,305.52a9.15,9.15,0,0,0,3.18-.64,8.55,8.55,0,0,0,3.25-2.29,8.67,8.67,0,0,0,2.14-5c.06-8.42,0-20.87,0-36.89,0-32,0-78.4-.09-135.68q0-21.48,0-45V77.12a15.56,15.56,0,0,0-.14-2.91,8.4,8.4,0,0,0-2.83-4.94,8.51,8.51,0,0,0-5.37-2H547.06l-107.54,0-246.41,0a8.44,8.44,0,0,0-6.81,3.46,8.16,8.16,0,0,0-1.5,3.62,33.53,33.53,0,0,0-.12,4V189.67q0,30.92,0,60.69v29.42c0,4.84,0,9.67,0,14.46,0,1.19,0,2.42.06,3.56a8.41,8.41,0,0,0,6.5,7.27,15.41,15.41,0,0,0,3.48.21h104l93.7,0,135.68.08,36.89.05,9.59,0,3.27,0-3.27,0-9.59,0-36.89.05-135.68.08-93.7,0h-104a15.47,15.47,0,0,1-3.58-.23,8.91,8.91,0,0,1-6.88-7.68c-.11-1.24,0-2.41-.06-3.61V279.78q0-14.55,0-29.42V189.67q0-30.91,0-62.87V78.4a33.48,33.48,0,0,1,.12-4.11,8.68,8.68,0,0,1,1.6-3.85,8.93,8.93,0,0,1,7.23-3.67l246.41,0,107.54,0H578a8.86,8.86,0,0,1,8.6,7.31,16.66,16.66,0,0,1,.14,3v2.94q0,23.44,0,45c0,57.28-.06,103.64-.08,135.68,0,16,0,28.46-.09,36.9a8.69,8.69,0,0,1-5.47,7.33,8.73,8.73,0,0,1-2.38.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.5,126.06v2.29H324V116h9.32v2.29h-6.48V121h5.72v2.22h-5.72v2.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.26,122.93v5.42h-2.75v-5c0-1.53-.7-2.24-1.92-2.24s-2.27.81-2.27,2.55v4.69h-2.74v-9.47h2.62V120a4.15,4.15,0,0,1,3.13-1.25C343.57,118.73,345.26,120,345.26,122.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.85,127.89a3.87,3.87,0,0,1-2.23.6c-2.24,0-3.54-1.14-3.54-3.4V121.2h-1.46v-2.11h1.46v-2.31h2.74v2.31h2.36v2.11h-2.36v3.86a1.11,1.11,0,0,0,1.19,1.25,1.83,1.83,0,0,0,1.1-.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.33,124.39h-7.16a2.52,2.52,0,0,0,2.71,1.9,3.19,3.19,0,0,0,2.37-.92l1.47,1.59a5,5,0,0,1-3.91,1.53c-3.28,0-5.41-2.06-5.41-4.88a4.83,4.83,0,0,1,5.05-4.88,4.69,4.69,0,0,1,4.93,4.92C364.38,123.86,364.35,124.16,364.33,124.39Zm-7.2-1.61h4.67a2.27,2.27,0,0,0-2.33-2A2.24,2.24,0,0,0,357.13,122.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.1,118.73v2.54c-.23,0-.41,0-.62,0a2.33,2.33,0,0,0-2.52,2.64v4.47h-2.74v-9.47h2.62v1.25A3.82,3.82,0,0,1,372.1,118.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.9,124v4.37h-2.85V124L377.28,116h3l3.3,5.48,3.29-5.48h2.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.93,123.61a5.22,5.22,0,1,1,5.22,4.88A4.88,4.88,0,0,1,388.93,123.61Zm7.63,0a2.43,2.43,0,1,0-2.41,2.63A2.39,2.39,0,0,0,396.56,123.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.72,118.88v9.47h-2.61v-1.13a3.83,3.83,0,0,1-2.94,1.27c-2.38,0-4.05-1.34-4.05-4.26v-5.35h2.75v4.94c0,1.59.7,2.29,1.92,2.29s2.18-.81,2.18-2.55v-4.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.15,118.73v2.54c-.23,0-.4,0-.61,0a2.32,2.32,0,0,0-2.52,2.64v4.47h-2.75v-9.47h2.62v1.25A3.82,3.82,0,0,1,419.15,118.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.26,122.19c0-3.67,2.85-6.38,6.75-6.38s6.74,2.7,6.74,6.38-2.87,6.37-6.74,6.37S425.26,125.85,425.26,122.19Zm10.6,0a3.86,3.86,0,1,0-3.85,3.94A3.76,3.76,0,0,0,435.86,122.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.28,118.35h-3.95V116h10.74v2.33h-3.94v10h-2.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.3,120.5c0,2.74-2.06,4.45-5.36,4.45h-2.48v3.4h-2.85V116h5.33C460.24,116,462.3,117.73,462.3,120.5Zm-2.89,0c0-1.36-.88-2.15-2.63-2.15h-2.32v4.28h2.32C458.53,122.63,459.41,121.83,459.41,120.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 277.94,
    y: 153.78,
    width: 31.29,
    height: 42.63,
    rx: 5.47,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 317.31,
    y: 153.78,
    width: 31.29,
    height: 42.63,
    rx: 5.47,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 356.69,
    y: 153.78,
    width: 31.29,
    height: 42.63,
    rx: 5.47,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 396.06,
    y: 153.78,
    width: 31.29,
    height: 42.63,
    rx: 5.47,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 435.43,
    y: 153.78,
    width: 31.29,
    height: 42.63,
    rx: 5.47,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 474.8,
    y: 153.78,
    width: 31.29,
    height: 42.63,
    rx: 5.47,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M296.85,175.27l3.75,2-1.68,2.82-3.78-2.24.06,4.16H292l0-4.19-3.78,2.27-1.65-2.82,3.74-2-3.74-2.06,1.65-2.82,3.78,2.27,0-4.19h3.23l-.06,4.19,3.78-2.27,1.68,2.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.78,
    y: 222.58,
    width: 98.48,
    height: 28.71,
    rx: 13.03,
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.5,236.26a4.46,4.46,0,0,1,7.72-2.76l-1.2,1.11a2.61,2.61,0,0,0-2-.94,2.59,2.59,0,0,0,0,5.18,2.6,2.6,0,0,0,2-1l1.2,1.11a4.45,4.45,0,0,1-7.72-2.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.67,237.19a3.43,3.43,0,1,1,3.43,3.21A3.21,3.21,0,0,1,372.67,237.19Zm5,0a1.6,1.6,0,1,0-1.58,1.73A1.57,1.57,0,0,0,377.68,237.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.07,236.74v3.56h-1.8V237c0-1-.47-1.47-1.26-1.47s-1.5.53-1.5,1.68v3.07h-1.8v-6.22h1.72v.73a2.75,2.75,0,0,1,2.06-.82A2.44,2.44,0,0,1,387.07,236.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.71,240a2.54,2.54,0,0,1-1.47.4,2.05,2.05,0,0,1-2.32-2.24v-2.55h-1v-1.39h1v-1.51h1.8v1.51h1.55v1.39h-1.55v2.53a.73.73,0,0,0,.78.82,1.24,1.24,0,0,0,.73-.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.51,232.21a1,1,0,0,1,1.12-1,1,1,0,0,1,1.12,1,1.13,1.13,0,0,1-2.24,0Zm.22,1.87h1.8v6.22h-1.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.57,236.74v3.56h-1.8V237c0-1-.47-1.47-1.26-1.47s-1.5.53-1.5,1.68v3.07h-1.8v-6.22h1.72v.73A2.75,2.75,0,0,1,401,234,2.44,2.44,0,0,1,403.57,236.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.47,234.08v6.22h-1.71v-.74a2.51,2.51,0,0,1-1.93.84,2.48,2.48,0,0,1-2.66-2.8v-3.52H407v3.25c0,1,.46,1.51,1.26,1.51s1.44-.54,1.44-1.68v-3.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.21,237.7H414.5a1.65,1.65,0,0,0,1.78,1.25,2.13,2.13,0,0,0,1.56-.6l1,1a3.63,3.63,0,0,1-6.12-2.2A3.17,3.17,0,0,1,416,234a3.08,3.08,0,0,1,3.24,3.23C419.24,237.36,419.22,237.55,419.21,237.7Zm-4.73-1h3.06a1.48,1.48,0,0,0-1.53-1.3A1.46,1.46,0,0,0,414.48,236.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.48,57.1a4.42,4.42,0,1,1-4.41-4.42A4.41,4.41,0,0,1,394.48,57.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.69,81.44V77.2a.87.87,0,0,1,.83-.91h6.37a.87.87,0,0,1,.83.91v4.24a.87.87,0,0,1-.83.91h-6.37A.87.87,0,0,1,556.69,81.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.77,83.79H556.19a1.13,1.13,0,0,1-1.12-1.13V75.73a1.12,1.12,0,0,1,1.12-1.12h12.4a1,1,0,0,1,1,1v1.28a.16.16,0,0,0,.16.16h1.36a.67.67,0,0,1,.67.67V80a.83.83,0,0,1-.83.83h-1a.17.17,0,0,0-.17.17v1.77A1,1,0,0,1,568.77,83.79Zm-12.58-8.68a.62.62,0,0,0-.62.62v6.93a.63.63,0,0,0,.62.63h12.58a.53.53,0,0,0,.52-.53V81a.67.67,0,0,1,.67-.67h1a.33.33,0,0,0,.33-.33V77.74a.18.18,0,0,0-.17-.17h-1.36a.67.67,0,0,1-.66-.66V75.63a.52.52,0,0,0-.53-.52Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-105"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.67,201.81a8.39,8.39,0,0,0-7.6-5.72c.88-2.47-.81-5.32-3.21-6.36a9.33,9.33,0,0,0-7.58.55c-1.67.79-3.23,1.89-5,2.3-2.37.54-4.82-.21-7.24-.29a13.55,13.55,0,0,0-12.17,7.09c-.81,1.53-1.31,3.22-2.2,4.71-.72,1.19-1.66,2.23-2.37,3.43a10.25,10.25,0,0,0,.82,11.31L160.21,211a8.18,8.18,0,0,0,12.46-9.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "251.2 327.33 218.33 324.07 216.43 341.14 253.55 339.85 251.2 327.33",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.17,337.33a1.85,1.85,0,0,1-1.9.74,2.2,2.2,0,0,1-.44-.17c-1-.49-.55-2.58-.55-2.58l-4.82-1.58s-7.08,3.12-9.8,5.51-8.2-.76-8.2-.76l-.36-10.86,10.4-6.79s-.64.41.23-1,3.64-.41,3.64-.41c.57-.69,2.48-.67,2.48-.67l7.83,2.18a5.52,5.52,0,0,1,3.6,3.15l2.53,5.87s1.18,4.13.75,5a1.61,1.61,0,0,1-2,.76s-.8,2.46-1.47,2.45a5.56,5.56,0,0,1-1.9-.79Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.67,337.83a3.36,3.36,0,0,0,.54-.29l1.5-.86a54.92,54.92,0,0,1,5.82-2.79h-.12l4.81,1.62-.14-.24a6.19,6.19,0,0,0-.1,1.23,2.29,2.29,0,0,0,.37,1.27,1.28,1.28,0,0,0,.61.41,1.78,1.78,0,0,0,.69.15,2.07,2.07,0,0,0,1.34-.49,2.13,2.13,0,0,0,.26-.26l.06-.07,0,0h0l-.31.06h0l.15.09a5.76,5.76,0,0,0,.6.33,4.67,4.67,0,0,0,.65.27,1.89,1.89,0,0,0,.36.1.84.84,0,0,0,.47,0,1.56,1.56,0,0,0,.59-.58,5.71,5.71,0,0,0,.35-.64,12.25,12.25,0,0,0,.54-1.35l-.32.15a1.9,1.9,0,0,0,1.94-.33,1.57,1.57,0,0,0,.5-.94,4.62,4.62,0,0,0,0-1,27,27,0,0,0-.8-3.77h0v0l-1.35-3.13-.85-2a10.18,10.18,0,0,0-1-1.95,5.34,5.34,0,0,0-1.6-1.47,7.08,7.08,0,0,0-2-.74l-7.39-2h-.06a7.66,7.66,0,0,0-1.37.14,2.27,2.27,0,0,0-1.28.62l.29,0a2.77,2.77,0,0,0-2.58-.26,3.25,3.25,0,0,0-1.59,1.82l.08-.1-7.17,4.65-1.93,1.29a5.6,5.6,0,0,0-.66.48,4.19,4.19,0,0,0,.72-.39l2-1.2,7.25-4.5,0,0,0-.06a2.88,2.88,0,0,1,1.39-1.58,2.38,2.38,0,0,1,2.18.25l.16.1.13-.14a1.9,1.9,0,0,1,1-.46,6.59,6.59,0,0,1,1.27-.12h0l7.37,2.08a6.61,6.61,0,0,1,1.85.69,4.84,4.84,0,0,1,1.44,1.34,9.12,9.12,0,0,1,.92,1.85c.29.66.57,1.32.86,2l1.35,3.13v0a26.47,26.47,0,0,1,.79,3.69,4.29,4.29,0,0,1,0,.87,1.07,1.07,0,0,1-.34.64,1.43,1.43,0,0,1-1.43.24l-.24-.08-.08.23a9.61,9.61,0,0,1-.51,1.29,2.45,2.45,0,0,1-.68,1,.85.85,0,0,1-.21,0l-.29-.08c-.2-.07-.4-.16-.6-.25a6.28,6.28,0,0,1-.57-.31l-.14-.08h0l-.31.06h0l0,0,0,.06a2,2,0,0,1-.21.2,1.61,1.61,0,0,1-1,.39,1.41,1.41,0,0,1-.54-.11.75.75,0,0,1-.42-.27,3.06,3.06,0,0,1-.22-2.14l0-.19-.17-.05-4.82-1.56-.06,0-.06,0a48.07,48.07,0,0,0-5.78,2.94c-.65.39-1.14.71-1.47.94A3.28,3.28,0,0,0,260.67,337.83Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.28,322.43a10.06,10.06,0,0,0,2.44,1.16,25.64,25.64,0,0,0,6.51,1.52l-.24-.22c.08.42.15.85.26,1.29a19.88,19.88,0,0,0,3.06,6.92,16.51,16.51,0,0,0,1.44,1.78c.37.4.6.59.63.57s-.74-.95-1.76-2.56a22.08,22.08,0,0,1-2.85-6.83c-.1-.42-.18-.85-.25-1.25l0-.21h-.2a31,31,0,0,1-6.44-1.33A23.66,23.66,0,0,0,265.28,322.43Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.12,328.27a13,13,0,0,0,4.24,8.75c.13-.11-1.33-1.77-2.49-4.19S272.28,328.24,272.12,328.27Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.39,335s.07.08.23.19a7.11,7.11,0,0,0,.74.43,8.83,8.83,0,0,0,3.09.86,8.73,8.73,0,0,0,4.78-.93,9.14,9.14,0,0,0,4.21-4.48l-.32.15a20.6,20.6,0,0,0,5.73,1.18,19.84,19.84,0,0,0,2.18,0,6.62,6.62,0,0,0,2.14-.35,1.65,1.65,0,0,0,.91-.75,1.53,1.53,0,0,0,.05-1.17,1.51,1.51,0,0,0-.79-.84l-.88-.38c-2.33-1-4.48-1.73-6.29-2.32s-3.31-1-4.34-1.26a7.92,7.92,0,0,0-1.63-.33,13.71,13.71,0,0,0,1.57.53c1,.32,2.48.79,4.28,1.42s3.91,1.43,6.22,2.42l.87.38a1,1,0,0,1,.51.55,1,1,0,0,1,0,.77,1.14,1.14,0,0,1-.65.5,6.15,6.15,0,0,1-2,.3c-.7,0-1.41,0-2.13,0a20.47,20.47,0,0,1-5.59-1.14l-.23-.08-.09.22a8.82,8.82,0,0,1-4,4.3,8.7,8.7,0,0,1-4.55,1,9.4,9.4,0,0,1-3-.7C249.75,335.21,249.41,335,249.39,335Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.58,285.09A14.91,14.91,0,0,1,130,270.16l-.62-49.51c-.58-13.29,6.46-24.72,19.39-24.94l1.2,0c12.05.51,21.69,10.44,22.16,22.83.44,11.53.91,22.66.59,28.82-.67,12.76-13.28,14-13.28,14s0,4.75,0,8.5a14.91,14.91,0,0,1-14.83,15.16Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.44,261.51a29.36,29.36,0,0,1-15.95-5.6s3.5,9.76,15.92,9.13Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.56,229.93a1.82,1.82,0,0,1-1.78,1.77A1.72,1.72,0,0,1,164,230a1.79,1.79,0,0,1,1.78-1.77A1.73,1.73,0,0,1,167.56,229.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.27,224.11c-.23.23-1.53-.85-3.44-.92s-3.34.84-3.54.59.15-.53.77-1a4.81,4.81,0,0,1,2.85-.77,4.55,4.55,0,0,1,2.72,1C169.2,223.57,169.38,224,169.27,224.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.25,229.93a1.8,1.8,0,0,1-1.78,1.77,1.73,1.73,0,0,1-1.76-1.72,1.8,1.8,0,0,1,1.78-1.77A1.72,1.72,0,0,1,150.25,229.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.57,223.77c-.23.23-1.54-.85-3.44-.92s-3.34.84-3.54.59.14-.53.77-1a4.81,4.81,0,0,1,2.85-.77,4.6,4.6,0,0,1,2.72,1C150.49,223.23,150.68,223.67,150.57,223.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.8,239.13a12.41,12.41,0,0,1,3.12-.44c.49,0,1-.11,1.05-.45a2.64,2.64,0,0,0-.27-1.5c-.41-1.23-.84-2.52-1.28-3.87-1.79-5.52-3-10-2.84-10.11s1.84,4.33,3.62,9.85c.43,1.36.84,2.65,1.22,3.89a2.93,2.93,0,0,1,.18,2,1.23,1.23,0,0,1-.83.69,3.27,3.27,0,0,1-.83.09A12.39,12.39,0,0,1,156.8,239.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.43,217.67c-.28.49-2.11-.12-4.36-.26s-4.14.13-4.35-.4c-.09-.25.31-.68,1.12-1a7.08,7.08,0,0,1,3.37-.54,7.16,7.16,0,0,1,3.26,1C151.22,216.94,151.55,217.43,151.43,217.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.59,218.35c-.41.44-2-.07-3.82-.14s-3.45.21-3.8-.27c-.16-.23.1-.67.8-1.07a6.22,6.22,0,0,1,6.15.33C169.56,217.67,169.77,218.14,169.59,218.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130,230.14c-.21-.1-8.42-2.95-8.5,5.78s8.46,7,8.48,6.77S130,230.14,130,230.14Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.43,239.35s-.15.11-.4.22a1.44,1.44,0,0,1-1.11,0c-.89-.35-1.64-1.82-1.66-3.4a5,5,0,0,1,.43-2.17,1.74,1.74,0,0,1,1.12-1.16.74.74,0,0,1,.87.43c.12.24.06.42.11.43s.18-.14.11-.5a.9.9,0,0,0-.33-.55,1,1,0,0,0-.81-.23,2.09,2.09,0,0,0-1.56,1.33,5.3,5.3,0,0,0-.53,2.43c0,1.76.9,3.42,2.12,3.8a1.56,1.56,0,0,0,1.35-.22C127.41,239.56,127.46,239.37,127.43,239.35Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.1,208.34a6.22,6.22,0,0,1,4.24-4.84,8.67,8.67,0,0,1,5.73.07c4.79,1.74,13,4.35,15.09,2.68,3.06-2.4,3.8-4,3.8-4l1.69,1.84c1.37-.78-2.75-5.36-6.13-6.94-5.1-2.38-12.89-3.85-17.6-2.48-5.67,1.65-10.38,4.54-13.23,9.85a35.13,35.13,0,0,0-3.75,17.53c0,1.85-.29,7.15,1.49,7.56,1.39.31,3.16.93,3.06,3.59a3.7,3.7,0,0,0,.88,2.67c1.55,1.7,3.45.1,4.33-1.5,1.87-3.42,2.08-7.5,2.24-11.42a26.27,26.27,0,0,0-.53-8.31,26.12,26.12,0,0,1-1.37-5.36A4.52,4.52,0,0,1,136.1,208.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.13,243.85c.05.13-.34.46-1.13.63a4.51,4.51,0,0,1-3.07-.48,4.66,4.66,0,0,1-2.08-2.31c-.3-.75-.25-1.25-.11-1.29s.93,1.66,2.72,2.63S157.05,243.56,157.13,243.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166,360.35l-40.62-8.94L99.27,286.72S64.38,294.46,58.63,314c-5,16.85-15.26,91.33,8.1,137.24a35.29,35.29,0,0,0,31.5,19.14H276a44.07,44.07,0,0,0,43.8-39.16c1-9,1.7-17.53,1.56-23.09l-28.54-21.9Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M274.6,382.85c12.51,16.34,27.73,31,45.93,40.62l.87-22.18-33.62-23.93Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M140.43,274.14c0,1.18,9.24,5,13.41,3.32,6.36-2.54,5.57-7.53,5.57-7.53l3.53,3.72,35.37,53.9L224.6,344.9l-42.08,13.33L138.4,307.55Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.28,256.05l-.93,1.74-4.2,7.83-17.47,11.14,35.93,42.71L159,358.23l39.3,12.3s-18.7-28.75-24.51-43.45-6.4-14-11.7-24.78A241.83,241.83,0,0,1,152.49,279Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.46,333l7.71,7.19,2.18,4.44-28.66-13.33L174,302.3s-7.37-16.35-9.9-22.21c-2.67-6.16-4.66-9.65-4.66-9.65l0-4.86L169.87,275l8.71,2.59,14.56,23Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.63,305.88s-3.48-7.42-6.32-13.59c-6.4-13.9-21.49-15.22-21.49-15.22l16.68,46.26,20.43,14.49s5.82,2,6.55,0c0,0,4.25-15.34,4.12-15.4s-14.54-4.37-14.54-4.37l-5.8-13",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.36,291.44l-19.85,33.07,20.79-.61,18.33-30.64a1.77,1.77,0,0,0-1.52-2.68H236.88A1.77,1.77,0,0,0,235.36,291.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159,328.84l49.69-5.91,8.35-14.63,6.54-3.59a3.25,3.25,0,0,1,3.49.22l.62.45,4.85-.61a3.82,3.82,0,0,1,2.39.47l3.44,2a1.66,1.66,0,0,1,.82,1.42h0a1.65,1.65,0,0,1-1.95,1.62l-3.34-.61-5.12,1.67s3.3.35,3.72,2.85-1.25,2.56-1.25,2.56,3.47,2,1,5c0,0,2.9,1.93-.35,5.59-2.19,2.48-18,10.56-18,10.56L159,358.23Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.17,321.73s.37,0,.81.45a2.62,2.62,0,0,1,.53,2.45,7.27,7.27,0,0,1-2.14,3.06,26.64,26.64,0,0,1-3.49,2.88,47.1,47.1,0,0,1-7.17,3.95,18.2,18.2,0,0,1-3.13,1.27,25.3,25.3,0,0,1,3-1.6,59.26,59.26,0,0,0,7-4.05,28.25,28.25,0,0,0,3.46-2.8,7.09,7.09,0,0,0,2.11-2.81,2.46,2.46,0,0,0-.32-2.22A3.17,3.17,0,0,0,232.17,321.73Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.51,305.51a7,7,0,0,1-2.48.94,7,7,0,0,1-2.62.44,6.83,6.83,0,0,1,2.48-.94A7,7,0,0,1,227.51,305.51Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.91,309.63a14,14,0,0,1-3.45,1.42,13.8,13.8,0,0,1-3.62.93,13.18,13.18,0,0,1,3.45-1.42A13.34,13.34,0,0,1,233.91,309.63Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228,316.26c-.15,0-.22-.45-.39-.94s-.37-.87-.26-1,.55.2.75.81S228.09,316.28,228,316.26Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.65,322c-.15,0-.09-.75-.3-1.56s-.57-1.43-.46-1.53.73.44,1,1.4S229.78,322,229.65,322Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.08,275.87c-1.66,1-15.71,10.6-13.66,26.32s33.15,51.26,39.64,51.94l24.95,4.1V328.84l-12-.68L131.33,297.4Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159,327.42a4.86,4.86,0,0,1-.89.08l-2.52.1-8.94.2h-.12l-.08-.1-6.32-8.5c-3.77-5.09-7.15-9.72-9.58-13.09l-2.85-4a11.08,11.08,0,0,1-1-1.52,11.59,11.59,0,0,1,1.16,1.39l3,3.9c2.51,3.3,6,7.9,9.71,13l6.27,8.53-.2-.1h8.94l2.52,0A3.68,3.68,0,0,1,159,327.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.94,282.84a6,6,0,0,1-.49-.89l-1.23-2.58.27,0a31.49,31.49,0,0,0-2.41,4.15,36.49,36.49,0,0,1-3.13,5.5l-.2.28-.21-.27c-1.62-2-3.47-4.11-5.46-6.28-4.35-4.73-8.51-8.83-11.48-11.83l-3.51-3.57a11,11,0,0,1-1.22-1.36,12,12,0,0,1,1.38,1.21l3.63,3.44c3,2.93,7.25,7,11.62,11.73,2,2.18,3.84,4.32,5.45,6.33l-.42,0a39.71,39.71,0,0,0,3.16-5.4,27.89,27.89,0,0,1,2.55-4.13l.16-.22.1.24c.45,1.08.82,1.95,1.1,2.64A4.17,4.17,0,0,1,152.94,282.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170,275.32a4.83,4.83,0,0,1,.75,1.48,39.25,39.25,0,0,1,1.31,4.13l.34,1.22-.78-1a33.72,33.72,0,0,0-3.66-3.87c-1.16-1.06-2.29-2-3.32-2.94l.42-.16a42.81,42.81,0,0,0-.15,4.93,5.24,5.24,0,0,1-.25,1.93c-.06,0,0-.71-.07-1.92a32.09,32.09,0,0,1,0-5l.05-.47.37.31c1,.87,2.2,1.84,3.37,2.92a29.43,29.43,0,0,1,3.68,4l-.44.21c-.43-1.73-.78-3.17-1.1-4.16A11.85,11.85,0,0,1,170,275.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.09,323.24a9.85,9.85,0,0,1-1.19-1.1L201.83,319c-1.29-1.35-2.82-2.86-4.5-4.73-.77-1-1.45-2.07-2.25-3.12a21,21,0,0,1-2.08-3.62c-1.19-2.58-2.09-5.13-2.9-7.44s-1.52-4.4-2.17-6.12-1.25-3.1-1.71-4a12.39,12.39,0,0,1-.72-1.44s.11.1.26.32a9.64,9.64,0,0,1,.65,1,33.58,33.58,0,0,1,1.89,4c.71,1.72,1.46,3.79,2.29,6.09s1.74,4.83,2.92,7.38a21.48,21.48,0,0,0,2,3.53c.81,1.07,1.49,2.18,2.22,3.13,1.57,1.79,3.14,3.41,4.37,4.77l2.95,3.25A9.53,9.53,0,0,1,206.09,323.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.51,339.83l94.32-2.65a10.63,10.63,0,0,1,4.36.81c3.43,1.46,9.6,5.21,13.83,14.19,6.13,13,34.73,68,34.73,68L338.83,435l-35.47-65.8L194,359.9l1.27-8.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.24,423.41l15.07,25.87,1,6.54a7.32,7.32,0,0,0,8.35,6.13l45.87-7a3.57,3.57,0,0,0,2.83-4.9,3.1,3.1,0,0,0-2.18-1.78c-3.84-1-33.44-11.85-33.44-11.85L355.4,411.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.87,429.4a28.29,28.29,0,0,1-3.39-4.16,27.07,27.07,0,0,1-3-4.47,28.63,28.63,0,0,1,3.38,4.16A27.56,27.56,0,0,1,342.87,429.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.87,425.78a18.19,18.19,0,0,1-3.16-4.36,18.72,18.72,0,0,1-2.24-4.9c.14-.07,1.2,2.09,2.69,4.64S352,425.69,351.87,425.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.16,461.12c-.1,0-.34-.89-1-2.24a13.35,13.35,0,0,0-8.93-7c-1.47-.35-2.42-.36-2.42-.46a5.65,5.65,0,0,1,2.51,0,12.26,12.26,0,0,1,9.23,7.25A5.88,5.88,0,0,1,358.16,461.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.07,456.67a3.84,3.84,0,0,1-.73-1.71,8,8,0,0,1,.22-4.51,10.82,10.82,0,0,1,2.39-3.81,4.74,4.74,0,0,1,1.42-1.2c.06.07-.41.6-1.1,1.48a13.85,13.85,0,0,0-2.14,3.73,8.92,8.92,0,0,0-.37,4.22A11.89,11.89,0,0,1,389.07,456.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.63,352.7s97.33-9.76,102.06-9.37c8.73.72,24.83,14.49,53.4,33.67a263.19,263.19,0,0,1,41,34.45l-9.13,20.84s-64-23.33-74.05-31.72c-8.34-7-23.56-16.9-23.56-16.9l-37.54.38-27.91,2.46a41,41,0,0,1-36.18-15.93l-10.83-14.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.88,383.38s.16.09.45.29l1.31.9,5.05,3.55c4.39,3.13,10.83,7.63,18.73,13.6.5.37,1,.8,1.5,1.13l1.61,1c1.16.58,2.32,1.22,3.55,1.79l3.76,1.75,4,1.75q8.11,3.51,17.49,7.32c12.48,5.07,26.48,10.58,41.59,16.39l-.33.15,8.27-21,.06.3-11.36-11.58h0c-2.67-2.31-5.53-4.77-8.45-7.2a597.48,597.48,0,0,0-54.56-40h0a53.2,53.2,0,0,0-8.26-5.81,41.19,41.19,0,0,0-8.83-3.84c-.76-.2-1.52-.36-2.27-.55l-2.27-.35-2.27-.12h-11l-29.39-.06-19.08-.08-5,0-1.3,0a3.72,3.72,0,0,1-.44,0l.44,0,1.3,0,5,0,19.08-.07,29.39-.06h11l2.31.11,2.32.35c.76.19,1.53.35,2.3.56a41,41,0,0,1,8.94,3.86,52.81,52.81,0,0,1,8.36,5.86l0,0a589.19,589.19,0,0,1,54.64,40c2.93,2.43,5.79,4.89,8.46,7.21h0l11.36,11.59.12.13-.06.17-8.3,21-.09.24-.24-.09c-15.11-5.83-29.11-11.37-41.58-16.47-6.23-2.55-12.07-5-17.47-7.37l-4-1.77L312.92,406c-1.22-.59-2.39-1.23-3.55-1.82l-1.65-1c-.54-.33-1-.76-1.5-1.13-7.86-6-14.28-10.55-18.63-13.73l-5-3.61-1.28-.94C281,383.5,280.88,383.38,280.88,383.38Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.26,427l27,10.61,4.49,4.86a7.33,7.33,0,0,0,10.36.4l34.06-31.52a3.58,3.58,0,0,0-.4-5.65,3.12,3.12,0,0,0-2.8-.25c-3.73,1.34-34.34,8.91-34.34,8.91L376.1,398Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.26,427s.09-.17.29-.51l.91-1.5c.81-1.35,2-3.3,3.51-5.8,3.08-5.07,7.52-12.35,13-21.29l.11-.19.18.14,20.53,16.32-.21,0,18.26-4.6,9.65-2.51c1.63-.44,3.28-.87,4.92-1.35l1.22-.38a5,5,0,0,1,1.32-.31,3.4,3.4,0,0,1,2.55,1,3.84,3.84,0,0,1,.37,5,7,7,0,0,1-.92,1l-.93.86-1.85,1.71-7.26,6.71-13.73,12.68-6.39,5.9-3.06,2.83a10.67,10.67,0,0,1-1.62,1.29,7.53,7.53,0,0,1-9.17-1c-1.72-1.79-3.28-3.54-4.81-5.19l.07,0c-8.33-3.32-15.07-6-19.76-7.88l-5.32-2.15-1.38-.56-.45-.19s.18.05.51.18l1.41.53,5.4,2.08,19.72,7.65h0l0,0c1.54,1.64,3.13,3.4,4.81,5.15a7.13,7.13,0,0,0,6.9,1.69,7,7,0,0,0,1.77-.79,9.92,9.92,0,0,0,1.54-1.25c1-.93,2-1.88,3.06-2.83q3.1-2.88,6.38-5.92c4.36-4,8.95-8.3,13.71-12.7q3.56-3.31,7.25-6.72l1.85-1.71a21,21,0,0,0,1.78-1.74,3.34,3.34,0,0,0-.3-4.34,2.86,2.86,0,0,0-2.17-.82,4.33,4.33,0,0,0-1.18.29l-1.25.38c-1.65.48-3.29.91-4.93,1.35l-9.66,2.5-18.26,4.57-.12,0-.09-.07L376,398.15l.29,0-13.09,21.06L359.57,425l-1,1.51C358.39,426.81,358.26,427,358.26,427Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.51,440.22c-.07.07-.78-.55-2.11-1.28a13.33,13.33,0,0,0-11.32-.81c-1.41.53-2.21,1.05-2.27,1a5.92,5.92,0,0,1,2.11-1.37,12.26,12.26,0,0,1,11.7.84A5.59,5.59,0,0,1,402.51,440.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.63,419.23a4.1,4.1,0,0,1-1.57-1,8,8,0,0,1-2.33-3.86,10.93,10.93,0,0,1-.16-4.5,4.53,4.53,0,0,1,.51-1.78,7.33,7.33,0,0,1-.08,1.83,13.32,13.32,0,0,0,.31,4.29,8.9,8.9,0,0,0,2.06,3.71C425.12,418.72,425.69,419.14,425.63,419.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.33,383.39c-2.09-9.91-6.36-20.05-14.81-25.62-6.41-4.24-14.34-5.28-22-6.22L68.06,331.94c-1.43,25.13,9.33,56.41,20.31,79.07,1.7,3.52,3.67,7.12,6.93,9.27,4,2.62,9.08,2.59,13.84,2.47,53.65-1.37,107.32-3.65,160.67-9.52C266.81,403.56,266.41,393.29,264.33,383.39Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.73,339.15a12.39,12.39,0,0,1-1.88-.12l-5.1-.55c-4.3-.5-10.23-1.23-16.77-2.13s-12.46-1.81-16.72-2.56c-2.14-.38-3.86-.69-5-1a12.44,12.44,0,0,1-1.83-.45,12.47,12.47,0,0,1,1.87.23l5.06.78c4.28.64,10.19,1.49,16.73,2.39l16.75,2.29,5.08.73A11.8,11.8,0,0,1,126.73,339.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.55,470.33a1.89,1.89,0,0,1-.16-.31c-.12-.23-.26-.54-.44-.92l-1.62-3.57L124.16,463c-.4-1-.79-2-1.24-3.14-.86-2.25-1.94-4.79-2.86-7.7-.48-1.44-1-2.95-1.51-4.53s-1-3.26-1.45-5c-1-3.43-1.86-7.17-2.78-11.09a181.52,181.52,0,0,1-3.61-52.12c.37-4,.66-7.82,1.22-11.36.27-1.77.45-3.49.75-5.13s.6-3.2.88-4.7c.51-3,1.23-5.67,1.77-8,.29-1.18.53-2.27.8-3.27s.56-1.9.8-2.72c.47-1.61.85-2.87,1.11-3.76l.31-1a1.68,1.68,0,0,1,.12-.33,1.26,1.26,0,0,1-.07.34l-.25,1-1,3.78-.75,2.73c-.25,1-.48,2.11-.75,3.28-.52,2.36-1.21,5-1.69,8-.26,1.49-.55,3.06-.84,4.69s-.46,3.35-.71,5.12c-.55,3.53-.82,7.34-1.18,11.34a186.86,186.86,0,0,0,3.6,52c.91,3.91,1.7,7.65,2.73,11.07.49,1.72.9,3.39,1.41,5s1,3.09,1.48,4.53c.89,2.91,1.94,5.45,2.77,7.72.44,1.13.81,2.19,1.2,3.15l1.12,2.59,1.52,3.61.39.95A1.43,1.43,0,0,1,127.55,470.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.86,419.66a34.61,34.61,0,0,1-6.27,0,35,35,0,0,1-6.26-.57,35.92,35.92,0,0,1,6.28,0A35.76,35.76,0,0,1,125.86,419.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.41,427a19.76,19.76,0,0,1-6.44-1.69,19.55,19.55,0,0,1-5.8-3.27c.09-.14,2.63,1.39,6,2.75S124.44,426.78,124.41,427Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.44,376.88a8.32,8.32,0,0,1-4.15,1.27,8.49,8.49,0,0,1-4.32-.45c0-.17,1.93.12,4.27-.11S110.38,376.73,110.44,376.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.63,374.48a7.09,7.09,0,0,1-4.58-.58,7,7,0,0,1-3.6-2.89,23.56,23.56,0,0,0,3.82,2.37C111.55,374.37,113.63,374.3,113.63,374.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.78,203.16a6.94,6.94,0,0,0-4.77-4.24,11.91,11.91,0,0,0-6.56.24l-20.72,4.74c3,2,9.17,3.88,12.71,4.26,5.17.55,8.81.6,11.89-1.18a3.88,3.88,0,0,0,5.45,2A5,5,0,0,0,169.78,203.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.79,420.52a41.33,41.33,0,0,1-12-4.52c.06-.14,2.7,1,6,2.24S376.83,420.38,376.79,420.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.35,411.66a57.77,57.77,0,0,1-5.31-2.51,54.74,54.74,0,0,1-5.27-2.58,24.1,24.1,0,0,1,5.5,2.11A23.16,23.16,0,0,1,381.35,411.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.31,348.91l41.77.51,50.44-10a4,4,0,0,0,3.13-3.28l6.86-45.42a3.35,3.35,0,0,0-3.85-3.8l-51.55,8.39a3.36,3.36,0,0,0-2.79,2.89l-5.75,46.19-38.2-.19a2.36,2.36,0,0,0-2.36,2.35h0A2.35,2.35,0,0,0,216.31,348.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.31,348.91a1.71,1.71,0,0,1-.79-.13,2.36,2.36,0,0,1-1.51-1.73,2.42,2.42,0,0,1,2-2.89c1.53-.06,3.26,0,5.24,0l33.31.08-.18.16c1.64-13.29,3.59-29,5.74-46.48a3.62,3.62,0,0,1,2.21-2.61,8.12,8.12,0,0,1,1.68-.35l1.66-.28,6.73-1.09,13.87-2.27L300.64,289l7.34-1.19,3.71-.61,1.86-.3a9.23,9.23,0,0,1,1.94-.21,3.64,3.64,0,0,1,3.15,2.51,4.29,4.29,0,0,1,.06,2.07l-.3,1.94q-.58,3.88-1.16,7.71c-.77,5.09-1.53,10.12-2.28,15.05s-1.48,9.76-2.19,14.5l-.54,3.52c-.09.59-.17,1.17-.26,1.75a5.21,5.21,0,0,1-.49,1.77,4.19,4.19,0,0,1-2.83,2.19l-3.38.67-47.15,9.28h0l-30.62-.45-8.27-.15L217,349l-.73,0,.73,0h2.15l8.28.05,30.62.29h0l47.13-9.4,3.37-.68a3.68,3.68,0,0,0,2.5-1.93,4.51,4.51,0,0,0,.43-1.62l.27-1.75c.17-1.17.35-2.35.53-3.53l2.18-14.5q1.11-7.39,2.27-15,.57-3.82,1.16-7.71l.29-1.94a3.65,3.65,0,0,0,0-1.83,3.1,3.1,0,0,0-2.69-2.15,9,9,0,0,0-1.81.2l-1.87.31-3.7.6-7.35,1.19-14.36,2.34-13.87,2.25-6.73,1.09-1.66.27a7.58,7.58,0,0,0-1.59.33,3.08,3.08,0,0,0-1.9,2.25c-2.2,17.42-4.18,33.15-5.85,46.43l0,.16h-.17l-33.31-.24c-2,0-3.73-.06-5.22,0a2.28,2.28,0,0,0-1.64,1.08,2.3,2.3,0,0,0,1.13,3.33A3.06,3.06,0,0,0,216.31,348.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.78,296.77c.14,0-1.24,12.07-3.09,26.93s-3.46,26.89-3.61,26.87,1.25-12.07,3.1-26.93S264.64,296.75,264.78,296.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.2,315.52c-1.05,2.19-.47,4.65,1.29,5.5s4-.25,5.09-2.44.47-4.65-1.29-5.49S288.25,313.33,287.2,315.52Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-105"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M668.68,296.65a1.52,1.52,0,0,1-.1.38l-.36,1.09c-.32.95-.78,2.35-1.43,4.15-1.26,3.6-3.16,8.79-5.67,15.14a346.88,346.88,0,0,1-23.15,48A107.1,107.1,0,0,0,631.36,379a61.54,61.54,0,0,0-3.54,13.62,97.33,97.33,0,0,0,0,23.85c.73,6.78,1.71,12.22,2.34,16,.32,1.85.57,3.31.75,4.33.08.47.14.84.18,1.12a2.33,2.33,0,0,1,.05.39,2.58,2.58,0,0,1-.1-.38c-.06-.27-.14-.64-.23-1.12-.2-1-.49-2.46-.85-4.31-.69-3.75-1.73-9.18-2.51-16a96.29,96.29,0,0,1-.06-24,61.3,61.3,0,0,1,3.53-13.73,106.23,106.23,0,0,1,6.64-13.7,361.15,361.15,0,0,0,23.25-47.89c2.56-6.32,4.51-11.49,5.83-15.07.66-1.77,1.17-3.15,1.52-4.12l.41-1.07C668.62,296.77,668.68,296.65,668.68,296.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659,356.62a4.09,4.09,0,0,1-.32.58l-1,1.61c-.88,1.4-2.19,3.4-3.81,5.86-3.24,4.93-7.86,11.64-12.51,19.34-2.3,3.86-4.35,7.62-6.07,11.11s-3.1,6.72-4.19,9.45-1.89,5-2.39,6.55c-.26.74-.46,1.34-.62,1.8a2.81,2.81,0,0,1-.25.61,2.67,2.67,0,0,1,.15-.64c.13-.47.31-1.08.52-1.83.45-1.59,1.22-3.85,2.24-6.62s2.39-6,4.1-9.53,3.75-7.3,6.07-11.17c4.65-7.72,9.33-14.4,12.64-19.28l3.95-5.76,1.09-1.56A3.24,3.24,0,0,1,659,356.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.58,296.65c.25-2.44-2.39-4.87-4.69-5.73a12.9,12.9,0,0,0-7.26,0A37.17,37.17,0,0,0,628.76,320a181.5,181.5,0,0,1,19.77-8.36l-1.14.33A23.07,23.07,0,0,0,663,300.55a12.36,12.36,0,0,1,2.09-3.2,3.09,3.09,0,0,1,3.51-.7",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.6,296.63a29.91,29.91,0,0,1,21.88-4.91,26.17,26.17,0,0,1,18.19,12.81,23.24,23.24,0,0,1,.11,22c-3.54-7.35-7.33-15-13.91-19.82-1.55-1.12-3.29-2.15-4.16-3.86-1-2-.59-4.41-1.46-6.45-1.06-2.51-4-3.25-6.71-3.39s-10.62,2.37-13.94,3.58",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.43,296.51c6.54-1.94,13.94,1.26,18.4,6.16s6.71,11.48,7.48,18.06.15,13.23-.52,19.82a82.65,82.65,0,0,1-11.27-25c-1-4-1.82-8.16-3.71-11.86a14.65,14.65,0,0,0-10.38-7.19",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.21,296.65c5.23-2.42,8.18-7.88,8.85-13.61a17.28,17.28,0,0,0-6.34-15.28,18.51,18.51,0,0,0-4.88,19.34c1.11,3.15,3.12,6.3,2.37,9.55",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.41,402.72a4.45,4.45,0,0,1-.33-.78c-.21-.52-.46-1.3-.87-2.28-.76-2-2-4.8-3.57-8.21a213,213,0,0,0-14.76-25.58,205,205,0,0,0-17.94-23.47,56.24,56.24,0,0,0-6.42-6.22,16.13,16.13,0,0,0-2-1.38,5.61,5.61,0,0,1-.74-.42,7.29,7.29,0,0,1,.79.32,15.48,15.48,0,0,1,2.07,1.32,51.84,51.84,0,0,1,6.56,6.13,189.69,189.69,0,0,1,18.1,23.43A195.59,195.59,0,0,1,622,391.29c1.58,3.45,2.73,6.3,3.43,8.3.38,1,.6,1.78.78,2.31A4.88,4.88,0,0,1,626.41,402.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "645.23 462.46 609.49 462.46 603.92 421.09 651.88 421.09 645.23 462.46",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.72,371.43c-3.61-7.75-12.89-12.81-21.41-12.12a6.59,6.59,0,0,1,3.55,4.72,40.08,40.08,0,0,1,.54,6.1c.77,9.79,7.07,18.14,13.11,25.87,4.25,5.43,8.53,10.89,13.61,15.56C687.51,397.64,686.63,382.89,678.72,371.43Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.31,359.42c5.41-4.16,12.39-5.89,19.22-6s13.57,1.4,20.18,3.08c4,1,8,2.12,11.41,4.42s6.11,6,6.17,10.09c-5.61-6.17-14.65-7.36-22.66-9.69-5.42-1.57-10.66-3.83-16.19-5a28.71,28.71,0,0,0-18.13,3",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.24,358.32c-2.37-2.49-1.06-8.31,1-11.05s5.35-4.29,8.59-5.44A59.64,59.64,0,0,1,681,338.76a13.56,13.56,0,0,1-4.17,7.33,39.9,39.9,0,0,1-6.94,5l-11.67,7.22",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636,355c-6.77,3-12,8.51-17.07,13.91a75.33,75.33,0,0,0,21.31-8.82c2.62-1.6,5.22-3.39,8.22-4.06s6.36.67,8.86,2.74C653.07,352.51,642.77,352,636,355Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.81,399.29c3.79-8.7,2.19-19.25,7-27.42,3.69-6.26,10.49-10,17.26-12.62,1.57,4.71.82,10-1.17,14.53s-5.15,8.49-8.48,12.17c-4.61,5.09-9.62,9.8-14.62,14.51",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 600.63,
    y: 421.09,
    width: 53.45,
    height: 9.31,
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.3,430.69c0,.15-11.57.26-25.83.26s-25.84-.11-25.84-.26,11.57-.26,25.84-.26S652.3,430.55,652.3,430.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671,297a59.28,59.28,0,0,0-6.21-9.35,19.87,19.87,0,0,0-9.13-6.29c-4.82-1.41-10-.29-14.8,1.14a118.49,118.49,0,0,0-16.43,6.26,32.56,32.56,0,0,0,21.84.39c3.68-1.25,7.25-1.09,11.11-.65,4.7.53,10.58,4.88,13.62,8.5",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.34,352.16c-8.42,10.72-11.23,25-10.28,38.64a92.59,92.59,0,0,1,29.88-46.41c5.5-4.56,12.52-8.18,19.33-8.18C568.26,335,552,341.1,543.34,352.16Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.9,330.63c-4.7.35-9,2.73-12.88,5.39-5.94,4.08-11.52,9.23-14.11,16a49.45,49.45,0,0,1,43.33-17.11C574.12,332.33,568.6,330.21,562.9,330.63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.06,314.53c-2.72,1.89-4.8,5-4.66,8.3a10.15,10.15,0,0,0,2.7,6.11,40.63,40.63,0,0,0,5.69,5.44c1.73-7.64,3.8-15.62,5.53-23.26A24.69,24.69,0,0,0,576.06,314.53Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592,313.8a22.82,22.82,0,0,0-8.74,9.51c-1.79,4-2.53,9-.28,12.74a326.91,326.91,0,0,1,20.84-27.84A68,68,0,0,0,592,313.8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.47,326.92a26.22,26.22,0,0,0-22.31,9.78,21.76,21.76,0,0,1,12-2.27,287.07,287.07,0,0,1,30.79,5.71A26.21,26.21,0,0,0,605.47,326.92Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.14,336.05c-7.94.44-14.88,6.55-17.65,14s-1.82,15.9,1.17,23.26,7.9,13.78,13.09,19.8c2.6-9,5.22-18,6.37-27.22S587.39,344.79,584.14,336.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M543.34,352.16c-8.42,10.72-11.23,25-10.28,38.64a92.59,92.59,0,0,1,29.88-46.41c5.5-4.56,12.52-8.18,19.33-8.18C568.26,335,552,341.1,543.34,352.16Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M562.9,330.63c-4.7.35-9,2.73-12.88,5.39-5.94,4.08-11.52,9.23-14.11,16a49.45,49.45,0,0,1,43.33-17.11C574.12,332.33,568.6,330.21,562.9,330.63Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M576.06,314.53c-2.72,1.89-4.8,5-4.66,8.3a10.15,10.15,0,0,0,2.7,6.11,40.63,40.63,0,0,0,5.69,5.44c1.73-7.64,3.8-15.62,5.53-23.26A24.69,24.69,0,0,0,576.06,314.53Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M592,313.8a22.82,22.82,0,0,0-8.74,9.51c-1.79,4-2.53,9-.28,12.74a326.91,326.91,0,0,1,20.84-27.84A68,68,0,0,0,592,313.8Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M605.47,326.92a26.22,26.22,0,0,0-22.31,9.78,21.76,21.76,0,0,1,12-2.27,287.07,287.07,0,0,1,30.79,5.71A26.21,26.21,0,0,0,605.47,326.92Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M584.14,336.05c-7.94.44-14.88,6.55-17.65,14s-1.82,15.9,1.17,23.26,7.9,13.78,13.09,19.8c2.6-9,5.22-18,6.37-27.22S587.39,344.79,584.14,336.05Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M678.72,371.43c-3.61-7.75-12.89-12.81-21.41-12.12a6.59,6.59,0,0,1,3.55,4.72,40.08,40.08,0,0,1,.54,6.1c.77,9.79,7.07,18.14,13.11,25.87,4.25,5.43,8.53,10.89,13.61,15.56C687.51,397.64,686.63,382.89,678.72,371.43Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M657.31,359.42c5.41-4.16,12.39-5.89,19.22-6s13.57,1.4,20.18,3.08c4,1,8,2.12,11.41,4.42s6.11,6,6.17,10.09c-5.61-6.17-14.65-7.36-22.66-9.69-5.42-1.57-10.66-3.83-16.19-5a28.71,28.71,0,0,0-18.13,3"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M658.24,358.32c-2.37-2.49-1.06-8.31,1-11.05s5.35-4.29,8.59-5.44A59.64,59.64,0,0,1,681,338.76a13.56,13.56,0,0,1-4.17,7.33,39.9,39.9,0,0,1-6.94,5l-11.67,7.22"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M636,355c-6.77,3-12,8.51-17.07,13.91a75.33,75.33,0,0,0,21.31-8.82c2.62-1.6,5.22-3.39,8.22-4.06s6.36.67,8.86,2.74C653.07,352.51,642.77,352,636,355Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M632.81,399.29c3.79-8.7,2.19-19.25,7-27.42,3.69-6.26,10.49-10,17.26-12.62,1.57,4.71.82,10-1.17,14.53s-5.15,8.49-8.48,12.17c-4.61,5.09-9.62,9.8-14.62,14.51"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-105"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M306.18,218.45H210a5,5,0,0,0-5,5v43.82a5,5,0,0,0,5,5h40.35l8.57,11,7.15-11h40.12a5,5,0,0,0,5-5V223.46A5,5,0,0,0,306.18,218.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.18,218.45h.48a4.75,4.75,0,0,1,1.37.31,4.94,4.94,0,0,1,1.89,1.28,5,5,0,0,1,1.31,2.86c.09,4.77.07,11.71.1,20.5,0,4.39,0,9.25,0,14.51,0,2.63,0,5.37,0,8.2a12.42,12.42,0,0,1-.1,2.18,5.05,5.05,0,0,1-.91,2.05,5.19,5.19,0,0,1-3.95,2.13l-40.36,0,.2-.11-7.14,11-.19.29-.21-.27-8.58-11,.2.1H211.49c-.7,0-1.36,0-2.1,0a5.27,5.27,0,0,1-4.54-4.07,9.36,9.36,0,0,1-.13-2.09v-2q0-8.15,0-16V232.81q0-3.8,0-7.5v-1.85a5.24,5.24,0,0,1,2.85-4.66,5.16,5.16,0,0,1,1.8-.55c.63-.06,1.21,0,1.81,0h10.52l13.3,0,23.89,0,34.59.08,9.4.05,2.45,0,.83,0-.83,0-2.45,0-9.4.05-34.59.08-23.89,0H211.2c-.59,0-1.2,0-1.76,0a4.48,4.48,0,0,0-1.63.5,4.77,4.77,0,0,0-2.58,4.23v9.35c0,5.05,0,10.22,0,15.47v18.07a9.17,9.17,0,0,0,.12,2,4.77,4.77,0,0,0,2.25,3.05,4.6,4.6,0,0,0,1.84.61c.64.06,1.36,0,2,0h39l.07.1,8.57,11-.4,0,7.15-11,.07-.11h.13l40.34,0a4.81,4.81,0,0,0,4.5-3.84,12.24,12.24,0,0,0,.1-2.11c0-2.83,0-5.57,0-8.2,0-5.26,0-10.12,0-14.51,0-8.78.07-15.75,0-20.49a5,5,0,0,0-3.08-4.08A6,6,0,0,0,306.18,218.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.7,
    y: 228.03,
    width: 12.14,
    height: 9.4,
    rx: 1.28,
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.9,228.28l4.62,4.93a1.87,1.87,0,0,0,1,.69,1.46,1.46,0,0,0,1.35-.52c.84-.86,1.64-1.75,2.46-2.62s1.56-1.65,2.33-2.48a.13.13,0,0,0-.18-.18l-4.41,4.7a3.87,3.87,0,0,1-.7.7c-.66.42-1.22,0-1.66-.47-.84-.88-1.67-1.77-2.5-2.66l-2.12-2.27c-.11-.11-.29.06-.18.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.85,237.37l3.71-4.22.52-.59c.11-.12-.07-.3-.17-.18-1.24,1.41-2.48,2.81-3.71,4.22l-.53.59c-.1.12.07.3.18.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.65,237l-3.47-4-.5-.58c-.11-.13-.28,0-.18.17l3.47,4c.17.2.34.39.5.59s.29-.06.18-.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.8,235.93v-3.11l-1.53,2.56h-.54l-1.52-2.5v3.05h-1.13v-5.19h1L241,234l1.91-3.23h1v5.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249,234.26h-3a1.06,1.06,0,0,0,1.14.8,1.34,1.34,0,0,0,1-.38l.62.67a2.1,2.1,0,0,1-1.65.64,2.07,2.07,0,0,1-2.28-2.05,2,2,0,0,1,2.13-2.06A2,2,0,0,1,249,234C249,234,249,234.17,249,234.26Zm-3-.67h2a1,1,0,0,0-2,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.36,235.56l.39-.83a2.69,2.69,0,0,0,1.38.39c.54,0,.74-.15.74-.37,0-.65-2.41,0-2.41-1.58,0-.75.68-1.29,1.84-1.29a3.33,3.33,0,0,1,1.54.35l-.39.82a2.28,2.28,0,0,0-1.15-.29c-.52,0-.74.16-.74.37,0,.68,2.41,0,2.41,1.59,0,.74-.69,1.27-1.88,1.27A3.36,3.36,0,0,1,249.36,235.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.3,235.56l.38-.83a2.75,2.75,0,0,0,1.39.39c.53,0,.73-.15.73-.37,0-.65-2.41,0-2.41-1.58,0-.75.68-1.29,1.85-1.29a3.26,3.26,0,0,1,1.53.35l-.38.82a2.31,2.31,0,0,0-1.15-.29c-.52,0-.74.16-.74.37,0,.68,2.41,0,2.41,1.59,0,.74-.69,1.27-1.89,1.27A3.35,3.35,0,0,1,253.3,235.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.15,233.65v2.28h-1.09v-.5a1.29,1.29,0,0,1-1.21.56c-.94,0-1.49-.52-1.49-1.21s.49-1.19,1.71-1.19H260c0-.5-.3-.79-.92-.79a1.93,1.93,0,0,0-1.15.37l-.41-.81a3.05,3.05,0,0,1,1.72-.48C260.44,231.88,261.15,232.45,261.15,233.65Zm-1.16,1v-.41h-.79c-.54,0-.72.2-.72.47s.25.48.66.48A.85.85,0,0,0,260,234.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.35,231.94v3.32a2,2,0,0,1-2.24,2.17,3.32,3.32,0,0,1-2-.55l.46-.83a2.42,2.42,0,0,0,1.41.45c.82,0,1.17-.37,1.17-1.09v-.17a1.61,1.61,0,0,1-1.26.5,1.93,1.93,0,1,1,0-3.86,1.61,1.61,0,0,1,1.32.57v-.51Zm-1.14,1.87a1.05,1.05,0,1,0-1,1A1,1,0,0,0,265.21,233.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.31,234.26h-3a1.06,1.06,0,0,0,1.14.8,1.33,1.33,0,0,0,1-.38l.62.67a2.1,2.1,0,0,1-1.65.64,2.07,2.07,0,0,1-2.27-2.05,2,2,0,0,1,2.12-2.06,2,2,0,0,1,2.08,2.07C271.33,234,271.32,234.17,271.31,234.26Zm-3-.67h2a1,1,0,0,0-2,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.71,235.56l.39-.83a2.72,2.72,0,0,0,1.39.39c.53,0,.73-.15.73-.37,0-.65-2.41,0-2.41-1.58,0-.75.68-1.29,1.85-1.29a3.29,3.29,0,0,1,1.53.35l-.38.82a2.33,2.33,0,0,0-1.15-.29c-.52,0-.75.16-.75.37,0,.68,2.41,0,2.41,1.59,0,.74-.68,1.27-1.88,1.27A3.39,3.39,0,0,1,271.71,235.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.89,233.34a2.84,2.84,0,1,1,2.84,2.68A2.69,2.69,0,0,1,277.89,233.34Zm4.46,0a1.63,1.63,0,1,0-1.62,1.66A1.59,1.59,0,0,0,282.35,233.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.47,231.72h-1.66v-1h4.52v1h-1.66v4.21h-1.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.48,232.62c0,1.16-.87,1.88-2.26,1.88h-1v1.43H289v-5.19h2.24C292.61,230.74,293.48,231.46,293.48,232.62Zm-1.22,0c0-.57-.37-.9-1.1-.9h-1v1.8h1C291.89,233.52,292.26,233.19,292.26,232.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221,251.11c0-4.9,2.72-7.68,6.36-7.68s6.37,2.78,6.37,7.68-2.7,7.68-6.37,7.68S221,256,221,251.11Zm9.27,0c0-3.37-1.19-4.77-2.91-4.77s-2.88,1.4-2.88,4.77,1.19,4.77,2.88,4.77S230.28,254.48,230.28,251.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.84,254.23c0,2.8-2.5,4.56-6.27,4.56s-6.24-1.76-6.24-4.56a3.78,3.78,0,0,1,2.25-3.5,3.44,3.44,0,0,1-1.72-3c0-2.61,2.33-4.25,5.71-4.25s5.74,1.64,5.74,4.25a3.44,3.44,0,0,1-1.74,3A3.75,3.75,0,0,1,247.84,254.23Zm-3.47-.11c0-1.31-1.09-2.12-2.8-2.12s-2.76.81-2.76,2.12,1.06,2.15,2.76,2.15S244.37,255.44,244.37,254.12Zm-5.09-6.3c0,1.13.89,1.83,2.29,1.83s2.33-.7,2.33-1.83S243,246,241.57,246,239.28,246.66,239.28,247.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.85,254.23c0,2.8-2.51,4.56-6.28,4.56s-6.24-1.76-6.24-4.56a3.78,3.78,0,0,1,2.25-3.5,3.44,3.44,0,0,1-1.72-3c0-2.61,2.34-4.25,5.71-4.25s5.75,1.64,5.75,4.25a3.46,3.46,0,0,1-1.74,3A3.76,3.76,0,0,1,261.85,254.23Zm-3.48-.11c0-1.31-1.08-2.12-2.8-2.12s-2.76.81-2.76,2.12,1.06,2.15,2.76,2.15S258.37,255.44,258.37,254.12Zm-5.09-6.3c0,1.13.89,1.83,2.29,1.83s2.33-.7,2.33-1.83S257,246,255.57,246,253.28,246.66,253.28,247.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.15,243.69v14.85h-3.44V246.45h-3v-2.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.83,255.74v2.8H271.61v-2.23l5.72-5.41c1.32-1.25,1.55-2,1.55-2.74,0-1.16-.8-1.84-2.37-1.84a3.64,3.64,0,0,0-3.08,1.48l-2.5-1.61a6.9,6.9,0,0,1,5.9-2.76c3.3,0,5.51,1.7,5.51,4.39,0,1.45-.4,2.76-2.48,4.69l-3.42,3.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.22,254c0,2.5-1.93,4.79-6.15,4.79a10.23,10.23,0,0,1-5.67-1.59l1.34-2.63a7.18,7.18,0,0,0,4.24,1.34c1.72,0,2.78-.7,2.78-1.91s-.83-1.83-2.78-1.83h-1.57V249.9l3.06-3.45h-6.32v-2.76h10.39v2.23l-3.35,3.81C293.86,250.16,295.22,251.81,295.22,254Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnterOtpPana);
export default __webpack_public_path__ + "static/media/Enter OTP-pana.96923ce68e1ed10e4ef3786967d11599.svg";
export { ForwardRef as ReactComponent };